var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExploreEducation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "education",
    xmlns: "http://www.w3.org/2000/svg",
    width: 61.877,
    height: 61.247,
    viewBox: "0 0 61.877 61.247",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_54294",
    "data-name": "Path 54294",
    d: "M94.326,225.111a12.607,12.607,0,0,0-.075,9.337l1.028,2.014H50.889s-8.264-4.644,0-12.908l44.006-.907Z",
    transform: "translate(-41.307 -195.1)",
    fill: "#f1f2f2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_54295",
    "data-name": "Path 54295",
    d: "M95.281,236.461H50.892s-8.264-4.644,0-12.908l44.007-.907-.571,2.464a12.087,12.087,0,0,0-.627,2H53.421a2.829,2.829,0,1,0,0,5.658H93.716a10.865,10.865,0,0,0,.537,1.677Z",
    transform: "translate(-41.31 -195.099)",
    fill: "#dee1e1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_54296",
    "data-name": "Path 54296",
    d: "M78.738,227.81l-40.575-.064c-4.861,0-9.036-3.1-9.036-7.962a11.075,11.075,0,0,1,.165-3.433A8.805,8.805,0,0,1,37.55,210.6H79.176a1.985,1.985,0,1,1,0,3.971h-31.5L44.6,215.3l-2.676-.722H37.55a4.831,4.831,0,1,0,0,9.662H79.176a1.987,1.987,0,0,1,1.972,2.219C81.032,227.441,79.756,227.81,78.738,227.81Z",
    transform: "translate(-25.439 -184.563)",
    fill: "#b7e546"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_54297",
    "data-name": "Path 54297",
    d: "M78.84,263.088a1.984,1.984,0,0,1-1.971,1.752L56.3,266.072,35.242,264.84a8.806,8.806,0,0,1-8.051-12.364v1.81a8.8,8.8,0,0,0,8.8,8.8Z",
    transform: "translate(-23.131 -221.196)",
    fill: "#abd641"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_54298",
    "data-name": "Path 54298",
    d: "M138.587,248.121v-5.788h-4.125L133,242.48l.088,5.391a.25.25,0,0,0,.341.233l1.035-.253,1.158-.453a.249.249,0,0,1,.182,0l2.443.957A.25.25,0,0,0,138.587,248.121Z",
    transform: "translate(-116.354 -212.323)",
    fill: "#ef5227"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_54299",
    "data-name": "Path 54299",
    d: "M133.329,242.336v5.517l-1.285.5a.25.25,0,0,1-.342-.233v-5.788Z",
    transform: "translate(-115.221 -212.325)",
    fill: "#d83724"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_54300",
    "data-name": "Path 54300",
    d: "M130.046,164.5v2.822l-.125,1.251a.876.876,0,0,1-.876.876l-33.351-.125a.875.875,0,0,1-.876-.876l-.25-3.948,17.121-.818Z",
    transform: "translate(-82.734 -143.51)",
    fill: "#fdcd08"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_54301",
    "data-name": "Path 54301",
    d: "M453.629,90.614a.938.938,0,0,1-.939-.939V79.94a.939.939,0,1,1,1.877,0v9.735A.939.939,0,0,1,453.629,90.614Z",
    transform: "translate(-396.041 -69.43)",
    fill: "#77777f"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_54302",
    "data-name": "Path 54302",
    d: "M429.4,189.039c-.783,1.931-1.572,3.836-2.355,5.767a1.753,1.753,0,0,0,1.609,2.419l1.449.125h3.524a1.753,1.753,0,0,0,1.609-2.419L433.6,190.9l-1.027-1.865H429.4Z",
    transform: "translate(-373.491 -165.698)",
    fill: "#fdcd08"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path_54303",
    "data-name": "Path 54303",
    d: "M429.791,189.31a4.757,4.757,0,0,0,2.94-.712l-.878-2.2-1.452.434h0l-1.892-.253c-.239.589-.587,1.426-.826,2.016h0l-1.633,4.026a1.753,1.753,0,0,0,1.608,2.419h2a1.753,1.753,0,0,1-1.608-2.419l1.22-3.006A.505.505,0,0,1,429.791,189.31Z",
    transform: "translate(-372.62 -163.392)",
    fill: "#faab18"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Path_54304",
    "data-name": "Path 54304",
    d: "M444.278,151.968a2.915,2.915,0,0,0-1.95-2.759c-.294-.1-.722.079-1.05.079a2.458,2.458,0,0,0-2.577,2.679,2.546,2.546,0,0,0,2.789,2.577c.328,0,.544.284.839.182A2.915,2.915,0,0,0,444.278,151.968Z",
    transform: "translate(-383.801 -130.825)",
    fill: "#fdcd08"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Path_54305",
    "data-name": "Path 54305",
    d: "M440.935,153.841A2.847,2.847,0,0,1,440,154a2.917,2.917,0,0,1,0-5.833,2.847,2.847,0,0,1,.939.158,2.927,2.927,0,0,0,0,5.517Z",
    transform: "translate(-382.408 -129.94)",
    fill: "#faab18"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Path_54306",
    "data-name": "Path 54306",
    d: "M62.156,14.031,53.9,16.888l-2.252-.231L35.628,23.214a5.251,5.251,0,0,1-3.436,0l-16.021-6.3-2.253-.025L5.664,14.031a1.05,1.05,0,0,1,0-1.985L32.505,2.754a4.294,4.294,0,0,1,2.81,0l26.841,9.292A1.05,1.05,0,0,1,62.156,14.031Z",
    transform: "translate(-4.337 -2.517)",
    fill: "#868491"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Path_54307",
    "data-name": "Path 54307",
    d: "M116.551,74.69v.847L98.277,81.863a5.251,5.251,0,0,1-3.436,0L76.568,75.538V74.69A3.682,3.682,0,0,1,79.6,71.064a96.111,96.111,0,0,1,33.917,0,3.685,3.685,0,0,1,3.033,3.627Z",
    transform: "translate(-66.986 -61.167)",
    fill: "#77777f"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Path_54308",
    "data-name": "Path 54308",
    d: "M131.8,90.438V97.9h-35.1l-.125-7.212a1.432,1.432,0,0,1,1.179-1.409c.358-.064.465-.376.823-.436a93.83,93.83,0,0,1,32.047.186,1.433,1.433,0,0,1,1.179,1.409Z",
    transform: "translate(-84.484 -76.914)",
    fill: "#868491"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Path_54309",
    "data-name": "Path 54309",
    d: "M130.046,167.318v1.377a.876.876,0,0,1-.876.876H95.444a.876.876,0,0,1-.876-.876v-4.2l1.126-.818,1.126.818v2.2a.626.626,0,0,0,.626.626Z",
    transform: "translate(-82.734 -143.51)",
    fill: "#faab18"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "Path_54310",
    "data-name": "Path 54310",
    d: "M96.821,97.846V106.9H94.568V99.44a1.432,1.432,0,0,1,1.179-1.409C96.1,97.967,96.463,97.9,96.821,97.846Z",
    transform: "translate(-82.734 -85.917)",
    fill: "#77777f"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "Path_54311",
    "data-name": "Path 54311",
    d: "M77.869,382.555a11.774,11.774,0,0,1,0-9.012l.381-1.692H27.079s-5.76,6.262.374,12.4l51.13.383Z",
    transform: "translate(-21.544 -325.634)",
    fill: "#f1f2f2"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "Path_54312",
    "data-name": "Path 54312",
    d: "M78.583,384.635l-51.13-.383c-6.136-6.134-.374-12.4-.374-12.4l51.417.1-.626,1.6a11.726,11.726,0,0,0-.559,1.707H30.346a2.829,2.829,0,1,0,0,5.658H77.325a11.871,11.871,0,0,0,.544,1.648Z",
    transform: "translate(-21.544 -325.637)",
    fill: "#dee1e1"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "Path_54313",
    "data-name": "Path 54313",
    d: "M60.879,368.44l-46.264-.085c-4.861,0-9.138-2.743-9.138-7.6,0-1.543-.377-3.667.32-4.928a8.8,8.8,0,0,1,7.707-4.548H61.748a1.985,1.985,0,1,1,0,3.971H49.795l-3.123.691-2.629-.691H13.5a4.831,4.831,0,0,0,0,9.662H61.748a1.987,1.987,0,0,1,1.953,2.344C63.532,368.177,61.853,368.44,60.879,368.44Z",
    transform: "translate(-4.702 -307.632)",
    fill: "#ef5227"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "Path_54314",
    "data-name": "Path 54314",
    d: "M59,395.729a1.988,1.988,0,0,1-1.953,1.627H8.8a8.8,8.8,0,0,1-7.426-13.53v3.1a8.8,8.8,0,0,0,8.8,8.8Z",
    transform: "translate(0 -336.109)",
    fill: "#d83724"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    id: "Path_54315",
    "data-name": "Path 54315",
    d: "M321.23,388.825V382.99h-3.875l-1.719.1.092,5.48a.25.25,0,0,0,.342.233l1.285-.351.908-.356a.25.25,0,0,1,.182,0l2.443.957A.25.25,0,0,0,321.23,388.825Z",
    transform: "translate(-276.137 -335.378)",
    fill: "#fdcd08"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    id: "Path_54316",
    "data-name": "Path 54316",
    d: "M316.249,382.986v5.467l-1.535.6a.25.25,0,0,1-.342-.233v-5.835Z",
    transform: "translate(-275.032 -335.374)",
    fill: "#faab18"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExploreEducation);
export default __webpack_public_path__ + "static/media/explore-education.8e176c2de31a00384bd91b0d0514d8e7.svg";
export { ForwardRef as ReactComponent };